import { render, staticRenderFns } from "./RecreationWidgetContent.vue?vue&type=template&id=fa62a39c&scoped=true"
import script from "./RecreationWidgetContent.vue?vue&type=script&lang=js"
export * from "./RecreationWidgetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa62a39c",
  null
  
)

export default component.exports